export default __webpack_public_path__ + "static/media/stl.7230bee1.svg";